module.exports = __webpack_public_path__ + "static/CollectiveRooftopTerrace-mobile-min-8122869801f63d61cbf7e1a554167e4e.jpg";